import * as React from 'react';
import { IPageWrapperViewProps } from './page-wrapper';

export default (props: IPageWrapperViewProps) => {
    const { slots } = props;
    return (
        <main className='CmsPage'>
            <div className='CmsPage-Wrapper CmsPage-Wrapper_page_width_default'>
                <div className='CmsPage-Content'>
                    {slots.headerSlot.length > 0 && slots.headerSlot[0]}
                    {slots.bodySlot &&
                        slots.bodySlot.map(node => {
                            return node;
                        })}
                    {slots.footerSlot.length > 0 && slots.footerSlot[0]}
                </div>
            </div>
        </main>
    );
};
